function updateLocalStorage() {
  return localStorage.setItem("QL_cart_v1", JSON.stringify(state.cart));
}

const state = {
  cart: localStorage.getItem("QL_cart_v1")
    ? JSON.parse(localStorage.getItem("QL_cart_v1"))
    : [],
  items: [
    {
      id: 1,
      value: "soyabean",
      name: "Soyabean",
      weight: "kg",
      price: 50000,
      grades: [
        {
          name: "grade 1",
          price: 50000
        },
        {
          name: "grade 2",
          price: 60000
        },
        {
          name: "grade 3",
          price: 70000
        }
      ]
    },
    {
      id: 2,
      value: "beans",
      name: "Beans",
      weight: "t",
      grades: [
        {
          name: "grade 1",
          price: 1200
        },
        {
          name: "grade 3",
          price: 1800
        }
      ]
    },
    {
      id: 3,
      value: "yam",
      name: "Yam",
      weight: "kg",
      grades: [
        {
          name: "grade 2",
          price: 2200
        }
      ]
    }
  ]
};

const getters = {
  cartItems(state) {
    return state.cart;
  },
  products(state) {
    return state.items;
  },
  cartItemCounter(state) {
    return state.cart.length;
  }
};

const actions = {
  addItemToCart({ commit }, payload) {
    commit("ADD_ITEM_TO_CART", payload);
  },

  updateCartItem({ commit }, payload) {
    commit("UPDATE_CART_ITEM", payload);
  },

  deleteCartItem({ commit }, payload) {
    commit("DELETE_CART_ITEM", payload);
  },

  emptyCart({ commit }) {
    commit("EMPTY_CART");
  }
};

const mutations = {
  ADD_ITEM_TO_CART(state, payload) {
    state.cart.push(payload);
    updateLocalStorage();
  },

  UPDATE_CART_ITEM(state, payload) {
    const { position, item } = payload;
    state.cart[position] = item;
    updateLocalStorage();
  },

  DELETE_CART_ITEM(state, item) {
    state.cart.splice(state.cart.indexOf(item), 1);
    // OR this.$delete(state.cart,index)  => https://vuejs.org/v2/api/#Vue-delete
    updateLocalStorage();
  },

  EMPTY_CART(state) {
    state.cart = [];
    // localStorage.removeItem("QL_cart_v1");
    updateLocalStorage();
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
